import { take, fork, select, put, call } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from "../../config/config";
import {getCurrentClubPlayerId, getGlobalAccount, getGlobalAccountBalance} from "../selectors";
import {showNotification} from "../actionCreators/notification";
import {successExchangeSapphires} from "../actionCreators/exchange";

function* exchangeSapphiresToCoins( amount ) {
    try {
        const { id: source, token } = yield select(getGlobalAccount);
        const { moneyName, diamondsName } = yield select(getGlobalAccountBalance);
        let params = {
            source,
            amount: amount,
            walletNameFrom: diamondsName,
            walletNameTo: moneyName,
            type: "walletsTransfer",
            token
        };
        console.log('exchangeSapphires: params: ', params);

        yield call(callApi, `${config.API_URL}/club/transaction`, 'POST', params);

        yield put(successExchangeSapphires());
        yield put(showNotification({message: 'Transfer succeeded !'}));
    } catch (e) {}
}
function* exchangeSapphiresToChips( amount ) {
    try {
        const { id: source, token } = yield select(getGlobalAccount);
        const destination = yield select(getCurrentClubPlayerId);
        const { moneyName, diamondsName } = yield select(getGlobalAccountBalance);
        let params = {
            source,
            destination,
            amount: amount,
            walletNameFrom: diamondsName,
            walletNameTo: moneyName,
            type: "accountsTransfer",
            token
        };
        console.log('exchangeSapphiresToChips: params: ', params);

        yield call(callApi, `${config.API_URL}/club/transaction`, 'POST', params);

        yield put(successExchangeSapphires());
        yield put(showNotification({message: 'Transfer succeeded !'}));
    } catch (e) {}
}


export function* watchExchangeSapphires() {
    while (true) {
        const action = yield take(actionTypes.EXCHANGE_SAPPHIRES_REQUEST);
        if(action.changeTo === 'coin') {
            yield fork(exchangeSapphiresToCoins, action.amount);

        } else {
            yield fork(exchangeSapphiresToChips, action.amount);
        }
    }
}
